/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

/**
 * applies flex row, and wrap padding to page
 */
const PageContent = ({ className, children }) => (
  <div className="page-content">
    <div className={`page-content-wrap wrap ${className}`}>{children}</div>
  </div>
);

PageContent.propTypes = propTypes;
PageContent.defaultProps = defaultProps;

export default PageContent;
